/*
 * ============================================================================
 * BUERO PROJECT - T27 Angebotsplaner - Rechenkern und Bedienung
 * Entwurfs-Theme "New Version Habitat 11.22 (Entwurf T27)" - nicht veroeffentlicht.
 *
 * Grundlage (alle am 01.09.2026 freigegeben):
 *   00_VARIANTEN_T27_anfragen_2026-09-01 §5.2  Aufwandsmodell (Lademeter + Personenstunden)
 *   00_ENTSCHEIDUNGSVORLAGE_T27_optimierung    M2-M12
 *   00_ENTSCHEIDUNGSVORLAGE_GF_T27             G1 G2 G3 G4 G7
 *   00_TESTBERICHT_T27_abdeckung §7            die sieben Rechenproben
 *   00_SPEZIFIKATION_T27_sonderwunschfeld      Fassung 4
 *   00_ABLAUF_T27_angebot-anfrage-conversion   Ablauf, Angebot, vier Zaehler
 *
 * Der Rechenkern liest ausschliesslich Werte, die als Metaobjekt im Shop stehen
 * (bp_paket, bp_servicesatz, bp_montagegebiet, bp_aufwand, bp_frachtsatz).
 * Es ist KEIN Preis in dieser Datei hart verdrahtet. Aendert MO eine Zahl im
 * Metaobjekt, rechnet der Planer sofort damit.
 *
 * Diese Datei ist zugleich das Pruefobjekt: sie laeuft unveraendert in Node
 * gegen die sieben Rechenproben (module.exports am Dateiende).
 * ============================================================================
 */
(function (root) {
  'use strict';

  var BP = {};

  /* ------------------------------------------------------------------ */
  /* 0 - Hilfsgroessen                                                    */
  /* ------------------------------------------------------------------ */

  var STUNDEN_JE_MONTAGETAG = 16; /* 2 Monteure x 8 Stunden */
  var LDM_JE_SENDUNG = 13.6;      /* eine volle Sattelzugladung */

  function r2(x) { return Math.round(x * 100) / 100; }
  function r1(x) { return Math.round(x * 10) / 10; }
  function eur(x) { return Math.round(x); }
  /* Deutsche Schreibweise auch in den Positionstexten - Komma statt Punkt (E35/E36). */
  function komma(x) { return String(x).replace('.', ','); }

  function satz(d, schluessel, ersatz) {
    var s = d.service && d.service[schluessel];
    if (!s || s.aktiv === false) { return ersatz === undefined ? null : ersatz; }
    return s.betrag;
  }

  function aufwand(d, schluessel) {
    return (d.aufwand && d.aufwand[schluessel]) || null;
  }

  function paket(d, schluessel) {
    for (var i = 0; i < d.pakete.length; i++) {
      if (d.pakete[i].schluessel === schluessel) { return d.pakete[i]; }
    }
    return null;
  }

  /* Welche Aufwandszeile gilt fuer ein Paket?
     Jedes Paket braucht Lademeter und Montagestunden, sonst rechnet der Planer
     Einbringen, Montage, Treppe, Uebernachtung und Fracht zu niedrig.

     Ein Arbeitsplatzpaket darf auf die allgemeine Zeile "arbeitsplatz" (0,94 LDM,
     1,0 Std) zurueckfallen - aber NUR, wenn es in bp_paket selbst dieselben
     Lademeter ausweist. Ein Paket mit zusaetzlichen Teilen (Einhausung,
     Akustik-Trennwand) traegt mehr und wuerde sonst mit dem Aufwand des
     billigsten Pakets gerechnet - genau die Klasse-C-Zelle, die dieser Auftrag
     auf null gebracht hat. Fehlt die Zeile, wird das Paket NICHT angeboten
     (Spezifikation §4: lieber nicht anbieten als falsch anbieten). */
  function aufwandFuerPaket(d, p) {
    if (!p) { return null; }
    var direkt = aufwand(d, p.schluessel);
    if (direkt) { return direkt; }
    if (p.schluessel === 'stauraum_schrank') { return aufwand(d, 'schrank_system44'); }
    if (p.schluessel.indexOf('paket_') === 0) {
      var basis = aufwand(d, 'arbeitsplatz');
      if (basis && basis.lademeter != null && p.ldm && Math.abs(p.ldm - basis.lademeter) < 0.0001) {
        return basis;
      }
    }
    return null;
  }
  BP.aufwandFuerPaket = aufwandFuerPaket;

  function praefix(plz) {
    return (String(plz || '').replace(/\D/g, '')).slice(0, 2);
  }

  function gebietFuer(d, plz) {
    var p = praefix(plz);
    if (p.length !== 2) { return null; }
    for (var i = 0; i < d.gebiete.length; i++) {
      if (d.gebiete[i].plz.indexOf(p) !== -1) { return d.gebiete[i]; }
    }
    return null;
  }

  function frachtzoneFuer(d, plz) {
    var p = praefix(plz);
    if (p.length !== 2) { return null; }
    for (var i = 0; i < d.frachtzonen.length; i++) {
      if (d.frachtzonen[i].plz.indexOf(p) !== -1) { return d.frachtzonen[i].zone; }
    }
    return null;
  }

  /* Frachtpreis einer einzelnen Sendung: kleinste Stufe, die die Lademeter traegt. */
  function frachtSendung(d, zone, ldm) {
    var beste = null;
    for (var i = 0; i < d.fracht.length; i++) {
      var f = d.fracht[i];
      if (f.zone !== zone) { continue; }
      if (f.stufe + 0.0001 < ldm) { continue; }
      if (beste === null || f.stufe < beste.stufe) { beste = f; }
    }
    return beste;
  }

  /* ------------------------------------------------------------------ */
  /* 1 - Vollstaendigkeit der Daten                                       */
  /* Leseregel 73 Zusatz 12: nachgewiesen wird durch Aufzaehlen, nicht    */
  /* ueber ein Zaehlfeld. Der Planer prueft seine eigene Datengrundlage,  */
  /* bevor er eine Zahl nennt - lieber kein Preis als ein falscher.       */
  /* ------------------------------------------------------------------ */

  BP.datenPruefen = function (d) {
    var m = [];
    if (!d || !d.pakete || !d.pakete.length) { m.push('bp_paket ist leer'); }
    if (!d || !d.gebiete || d.gebiete.length < 5) {
      m.push('bp_montagegebiet unvollstaendig (' + ((d && d.gebiete && d.gebiete.length) || 0) + ' statt 5)');
    }
    var noetigeSaetze = ['einbringen_je_lademeter', 'montage_je_personenstunde', 'grundpauschale_klein',
      'demontage_alt_zerlegbar', 'demontage_alt_massiv', 'entsorgung_alt_zerlegbar', 'entsorgung_alt_massiv',
      'treppe_bis_2og', 'treppe_ab_3og', 'zufahrt_kleinfahrzeug', 'tragweg_ueber_30m',
      'uebernachtung', 'kleinauftragszuschlag_450', 'montage_schrankkorpus'];
    for (var i = 0; i < noetigeSaetze.length; i++) {
      if (satz(d, noetigeSaetze[i]) === null) { m.push('bp_servicesatz fehlt: ' + noetigeSaetze[i]); }
    }
    if (!aufwand(d, 'arbeitsplatz')) { m.push('bp_aufwand fehlt: arbeitsplatz'); }

    /* Die Frachttafel muss 5 Zonen x 12 Stufen fuehren. Liquid liefert ohne
       Paginierung nur 50 von 60 Eintraegen - genau diese stille Luecke faengt
       die folgende Pruefung ab. */
    var stufen = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 13.6];
    for (var z = 1; z <= 5; z++) {
      for (var s = 0; s < stufen.length; s++) {
        var gefunden = false;
        for (var f = 0; f < (d.fracht || []).length; f++) {
          if (d.fracht[f].zone === z && Math.abs(d.fracht[f].stufe - stufen[s]) < 0.0001) { gefunden = true; break; }
        }
        if (!gefunden) { m.push('bp_frachtsatz fehlt: Zone ' + z + ' Stufe ' + stufen[s]); }
      }
    }
    if (!d || !d.frachtzonen || d.frachtzonen.length < 5) { m.push('Frachtzonen-Zuordnung unvollstaendig'); }
    return m;
  };

  /* ------------------------------------------------------------------ */
  /* 2 - Der Rechenkern                                                   */
  /* ------------------------------------------------------------------ */

  BP.rechne = function (e, d, opt) {
    opt = opt || {};
    var maxSendungen = opt.maxSendungen || 3;              /* G3 */
    var sperren = opt.sperrenPruefen === false ? false : true;

    var erg = {
      status: 'preis', grund: '', text: '',
      moebel: 0, leistungen: 0, fracht: 0, gesamt: 0,
      ldm: 0, stunden: 0, tage: 0, naechte: 0,
      gebiet: null, frachtzone: null, sendungen: [],
      moebelPositionen: [], leistungsPositionen: [], frachtPositionen: [],
      hinweise: []
    };

    var ap = Math.max(0, parseInt(e.ap, 10) || 0);
    var p = paket(d, e.paket);
    if (!p) { erg.status = 'unvollstaendig'; erg.grund = 'paket'; return erg; }

    /* -- Untergrenze: unterhalb von 5 Arbeitsplaetzen zeigt der Planer die Sets -- */
    if (sperren && ap < 5) {
      erg.status = 'sets'; erg.grund = 'unter_5_ap';
      erg.text = 'Unter fünf Arbeitsplätzen rechnen wir nicht im Planer — dafür haben wir fertige Sets mit festem Preis.';
      return erg;
    }

    /* -- Gebiet und Frachtzone --
       Ä256: Die Pruefung auf die Postleitzahl steht hinter der Moebelrechnung.
       Bis dahin liest keine Zeile Gebiet oder Frachtzone. */
    var gebiet = gebietFuer(d, e.plz);
    var fzone = frachtzoneFuer(d, e.plz);
    erg.gebiet = gebiet;
    erg.frachtzone = fzone;

    /* -- Elemente sammeln: Arbeitsplaetze, Zusatzbereiche, Schraenke -- */
    var elemente = [];
    elemente.push({ schluessel: p.schluessel, bezeichnung: p.bezeichnung, anzahl: ap, preis: p.preis, ldm: p.ldm });

    if (e.besprechung) {
      var b = paket(d, e.besprechung);
      var bn = Math.max(1, parseInt(e.besprechungAnzahl, 10) || 1);
      if (b) { elemente.push({ schluessel: b.schluessel, bezeichnung: b.bezeichnung, anzahl: bn, preis: b.preis, ldm: b.ldm }); }
    }
    if (e.empfang) {
      var em = paket(d, e.empfang);
      if (em) { elemente.push({ schluessel: em.schluessel, bezeichnung: em.bezeichnung, anzahl: 1, preis: em.preis, ldm: em.ldm }); }
    }
    var schraenke = Math.max(0, parseInt(e.schraenke, 10) || 0);
    if (schraenke > 0) {
      var st = paket(d, 'stauraum_schrank');
      if (st) { elemente.push({ schluessel: 'stauraum_schrank', bezeichnung: st.bezeichnung, anzahl: schraenke, preis: st.preis, ldm: st.ldm }); }
    }

    /* Kein Element ohne Aufwandszeile - sonst entsteht ein zu niedriger Preis. */
    for (var q = 0; q < elemente.length; q++) {
      var aq = aufwandFuerPaket(d, paket(d, elemente[q].schluessel));
      if (!aq) {
        erg.status = 'unvollstaendig'; erg.grund = 'aufwand_fehlt';
        erg.text = 'Für „' + elemente[q].bezeichnung + '“ liegt der Montageaufwand noch nicht vor. Sagen Sie uns unten kurz, was Sie brauchen — wir rechnen es für Sie.';
        return erg;
      }
      elemente[q].aufwand = aq;
    }

    /* -- Moebel, Lademeter, Montagestunden der neuen Elemente --
       Lademeter und Stunden kommen aus bp_aufwand; fehlt dort ein Element,
       traegt der Paketsatz die Lademeter (bp_paket.ldm_je_arbeitsplatz). */
    var moebel = 0, ldm = 0, stdElemente = 0, montageKosten = 0;
    var satzMontageStunde = satz(d, 'montage_je_personenstunde');
    var satzKorpus = satz(d, 'montage_schrankkorpus');

    for (var i = 0; i < elemente.length; i++) {
      var el = elemente[i];
      var aw = el.aufwand;
      var elLdm = (aw && aw.lademeter != null) ? aw.lademeter : el.ldm;
      var elStd = (aw && aw.montagestunden != null) ? aw.montagestunden : 0;

      moebel += el.anzahl * el.preis;
      ldm += el.anzahl * elLdm;
      stdElemente += el.anzahl * elStd;

      erg.moebelPositionen.push({
        bezeichnung: el.bezeichnung, menge: el.anzahl, einzel: el.preis,
        betrag: el.anzahl * el.preis, ldm: r2(el.anzahl * elLdm)
      });

      /* Montagekosten: je Personenstunde - beim Schrankkorpus gilt der
         veroeffentlichte Satz von 25 EUR statt 0,4 Std x 60 EUR = 24 EUR
         (Variantenblatt §5.2, "der veroeffentlichte Satz bleibt"). */
      if (el.schluessel === 'stauraum_schrank') {
        montageKosten += el.anzahl * satzKorpus;
      } else {
        montageKosten += el.anzahl * elStd * satzMontageStunde;
      }
    }

    ldm = r2(ldm);
    erg.ldm = ldm;
    erg.moebel = eur(moebel);

    /* Ä256: Ohne Postleitzahl zeigt der Planer die Moebelsumme als vorlaeufigen
       Preis. Leistungen und Fracht brauchen Gebiet und Frachtzone - erst ab hier.
       Kein Festpreis, keine Preisbindung, kein Zaehler rechner_abgeschlossen. */
    if (!gebiet || !fzone) {
      erg.status = 'vorlaeufig'; erg.grund = 'plz';
      erg.text = 'Lieferung und Montage rechnen wir dazu, sobald Sie die Postleitzahl des Lieferorts eingeben.';
      return erg;
    }

    /* -- Zugang: Treppe oder Personenaufzug -- */
    var stockwerk = Math.max(0, parseInt(e.stockwerk, 10) || 0);
    var zuFuss = stockwerk >= 1 && (e.aufzug === 'person' || e.aufzug === 'kein');
    var treppenSatz = zuFuss ? (stockwerk <= 2 ? satz(d, 'treppe_bis_2og') : satz(d, 'treppe_ab_3og')) : 0;
    var treppe = zuFuss ? ldm * stockwerk * treppenSatz : 0;
    var stdTreppe = zuFuss ? treppe / satzMontageStunde : 0;

    /* -- Altmoebel: 1:1-Kopplung, Bauart entscheidet den Satz -- */
    var altAnzahl = Math.max(0, parseInt(e.altAnzahl, 10) || 0);
    var massiv = e.altBauart === 'massiv';
    if (altAnzahl > ap) {
      erg.hinweise.push('ueberhang_alt');
      altAnzahl = ap; /* §9.2: der Ueberhang ist nicht 1:1 gekoppelt */
    }
    var satzDem = massiv ? satz(d, 'demontage_alt_massiv') : satz(d, 'demontage_alt_zerlegbar');
    var satzEnt = massiv ? satz(d, 'entsorgung_alt_massiv') : satz(d, 'entsorgung_alt_zerlegbar');
    var awAlt = aufwand(d, massiv ? 'alt_arbeitsplatz_massiv' : 'alt_arbeitsplatz_zerlegbar');
    var stdAlt = altAnzahl * ((awAlt && awAlt.montagestunden != null) ? awAlt.montagestunden : (massiv ? 2 : 1));

    /* -- Zufahrt -- */
    var engeZufahrt = e.zufahrt === 'eng';
    var zufahrtKosten = 0;

    /* -- Zweig "nur Lieferung" (M8): ohne Montage faehrt kein Team.
          Dann entfallen Einbringen, Montage, Anfahrt, Treppe, Uebernachtung,
          Grund- und Kleinauftragspauschale. Es bleiben Fracht und - bei enger
          Zufahrt - der Umschlag auf ein Kleinfahrzeug. -- */
    var montage = e.montage !== false;

    var einbringen = 0, anfahrt = 0, grundpauschale = 0, kleinauftrag = 0, uebernachtung = 0;
    var stdGesamt = 0, tage = 0, naechte = 0;

    if (montage) {
      einbringen = ldm * satz(d, 'einbringen_je_lademeter');
      anfahrt = gebiet.anfahrt;
      if (ap < 10) { grundpauschale = satz(d, 'grundpauschale_klein'); }
      if (gebiet.zone === 3 && ap >= 5 && ap <= 9) { kleinauftrag = satz(d, 'kleinauftragszuschlag_450'); } /* G2 */
      if (engeZufahrt) { zufahrtKosten = satz(d, 'zufahrt_kleinfahrzeug') + ldm * satz(d, 'tragweg_ueber_30m'); }

      stdGesamt = r1(stdElemente + stdAlt + stdTreppe);
      tage = Math.max(1, Math.ceil(stdGesamt / STUNDEN_JE_MONTAGETAG));
      /* Uebernachtungen nach Entfernung des Montagegebiets:
         Zone 1 faehrt das Team taeglich, Zone 2 uebernachtet einen Tag weniger
         als es montiert, Zone 3 genau so oft, ab Zone 4 kommt die Anreise dazu. */
      if (gebiet.zone === 1) { naechte = 0; }
      else if (gebiet.zone === 2) { naechte = Math.max(0, tage - 1); }
      else if (gebiet.zone === 3) { naechte = tage; }
      else { naechte = tage + 1; }
      uebernachtung = naechte * satz(d, 'uebernachtung');
    } else {
      montageKosten = 0;
      treppe = 0;
      satzDem = 0; satzEnt = 0; altAnzahl = 0;
      if (engeZufahrt) { zufahrtKosten = satz(d, 'zufahrt_kleinfahrzeug'); }
      stdGesamt = 0; tage = 0; naechte = 0;
    }

    erg.stunden = stdGesamt;
    erg.tage = tage;
    erg.naechte = naechte;

    /* -- Sperren: lieber kein Preis als ein falscher (Klasse C auf null) -- */
    if (sperren) {
      if (e.zufahrt === 'fuss') {
        erg.status = 'anfrage'; erg.grund = 'fussgaengerzone';
        erg.text = 'In einer Fußgängerzone oder mit Halteverbotszone planen wir die Anlieferung mit Ihnen — Genehmigung und Lieferfenster brauchen Vorlauf.';
        return erg;
      }
      if (montage && zuFuss) { /* G7 */
        if (stockwerk >= 3 || ldm > 20 || ldm * stockwerk > 30) {
          erg.status = 'anfrage'; erg.grund = 'treppe';
          erg.text = 'In dieser Größe und Höhe arbeiten wir mit einem Möbellift. Den planen wir gemeinsam.';
          return erg;
        }
      }
      if (montage && gebiet.zone >= 4 && ap < 10) { /* G1 */
        erg.status = 'anfrage'; erg.grund = 'weit_und_klein';
        erg.text = 'Über 450 Kilometer rechnen wir ab zehn Arbeitsplätzen. Wir machen Ihnen trotzdem gern ein Angebot.';
        return erg;
      }
      if (ldm > LDM_JE_SENDUNG * maxSendungen + 0.0001) { /* G3 */
        erg.status = 'anfrage'; erg.grund = 'ueber_drei_sendungen';
        erg.text = 'Ab dieser Größe fährt Ihre Einrichtung in mehreren Sendungen. Die rechnen wir einzeln.';
        return erg;
      }
    }

    /* -- Fracht: volle Sendungen zu 13,6 Lademetern, Rest in der passenden Stufe -- */
    var rest = ldm, fracht = 0, n = 0;
    while (rest > 0.0001 && n < maxSendungen) {
      var teil = Math.min(LDM_JE_SENDUNG, r2(rest));
      var f = frachtSendung(d, fzone, teil);
      if (!f) { erg.status = 'unvollstaendig'; erg.grund = 'frachtstufe'; return erg; }
      fracht += f.betrag;
      erg.frachtPositionen.push({ bezeichnung: 'Sendung ' + (n + 1) + ' · ' + komma(r2(teil)) + ' Lademeter · Frachtzone ' + fzone, betrag: f.betrag });
      rest = r2(rest - teil);
      n++;
    }
    erg.sendungen = erg.frachtPositionen.slice();
    erg.fracht = eur(fracht);

    /* -- Leistungen zusammenstellen -- */
    function pos(bez, betrag, zusatz) {
      if (!betrag) { return; }
      erg.leistungsPositionen.push({ bezeichnung: bez, betrag: betrag, zusatz: zusatz || '' });
    }
    pos('Einbringen und Verteilen bis an den Aufstellort', einbringen, komma(r2(ldm)) + ' Lademeter × ' + satz(d, 'einbringen_je_lademeter') + ' €');
    pos('Montage', montageKosten, montage ? (r1(stdElemente) + ' Personenstunden') : '');
    if (altAnzahl > 0) {
      pos('Demontage der Altmöbel, ' + (massiv ? 'massive' : 'zerlegbare') + ' Bauart', altAnzahl * satzDem, altAnzahl + ' × ' + satzDem + ' €');
      pos('Mitnahme und Entsorgung, ' + (massiv ? 'massive' : 'zerlegbare') + ' Bauart', altAnzahl * satzEnt, altAnzahl + ' × ' + satzEnt + ' €');
    }
    pos('Transport über die Treppe, ' + stockwerk + '. Obergeschoss', treppe, komma(r2(ldm)) + ' Lademeter × ' + stockwerk + ' Etagen × ' + treppenSatz + ' €');
    pos('Eingeschränkte Zufahrt', zufahrtKosten, montage ? 'Umschlag Kleinfahrzeug und Tragweg' : 'Umschlag Kleinfahrzeug');
    pos('Anfahrt Montageteam · ' + gebiet.bezeichnungKurz, anfahrt);
    pos('Kleinauftragszuschlag', kleinauftrag, '5 bis 9 Arbeitsplätze im Gebiet bis 450 km');
    pos('Grundpauschale kleiner Auftrag', grundpauschale, 'entfällt ab 10 Arbeitsplätzen');
    pos('Übernachtung des Montageteams', uebernachtung, naechte + ' Nächte × ' + satz(d, 'uebernachtung') + ' €');

    var leistungen = einbringen + montageKosten + altAnzahl * satzDem + altAnzahl * satzEnt +
      treppe + zufahrtKosten + anfahrt + kleinauftrag + grundpauschale + uebernachtung;

    erg.leistungen = eur(leistungen);
    erg.gesamt = erg.moebel + erg.leistungen + erg.fracht;
    return erg;
  };

  /* ------------------------------------------------------------------ */
  /* 3 - Bedienung im Browser                                             */
  /* ------------------------------------------------------------------ */

  var PLATZHALTER = [
    'Tischplatten in Eiche natur, passend zu unserem Empfangstresen.',
    'Wir brauchen eine Sonderbreite von 180 cm für vier der Plätze.',
    'Schränke in RAL 7016, gleiche Farbe wie unser Bestand aus 2023.',
    'Akustikelemente mit unserem Logo bedruckt, Datei liefern wir.',
    'Zusätzlich ein Loungebereich für den Empfang, etwa 6 Sitzplätze.',
    '30 alte Arbeitsplätze werden abgebaut, wir bauen 20 neue auf.',
    'Die Montage muss an einem Samstag laufen, der Betrieb geht weiter.',
    'Der Aufzug ist da, aber die Kabine ist nur 1,00 × 1,25 m.',
    'Anlieferung nur über den Innenhof, LKW kommt nicht bis an die Tür.',
    'Die alten Schränke sind Vollholz und lassen sich nicht zerlegen.'
  ];

  function geld(x) {
    return new Intl.NumberFormat('de-DE', { minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(Math.round(x)) + ' €';
  }
  function zahl(x, n) {
    return new Intl.NumberFormat('de-DE', { minimumFractionDigits: n, maximumFractionDigits: n }).format(x);
  }
  function el(id) { return document.getElementById(id); }

  /* -- Die vier Zaehler fuer Tor G2 ---------------------------------------
     rechner_gestartet    - erste Eingabe im Planer
     rechner_abgeschlossen- ein gueltiger Preis steht auf dem Bildschirm
     angebot_angefordert  - die Anfrage ist beim Server ANGEKOMMEN, nicht beim Klick
     angebot_pdf          - das Dokument wurde erzeugt
     ------------------------------------------------------------------- */
  var gefeuert = {};
  function zaehler(name, werte) {
    if (gefeuert[name]) { return; }
    gefeuert[name] = true;
    var cfg = (root.BP_AP_CFG || {});
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: name }, werte || {}));

    /* >>> PLATZHALTER CONVERSION-LABEL <<<
       Das Label zu AW-18163640732 wird bei der Agentur abgearbeitet
       (V25 §5.4, Ablauf §7 Punkt 4). Sobald es vorliegt, traegt MO es im
       Theme-Editor unter "Conversion-Label ..." ein - eine Zeile je Zaehler,
       kein Eingriff in diese Datei noetig. Solange das Feld leer ist, laeuft
       nur der dataLayer-Zaehler; es wird bewusst KEIN Ersatzlabel geraten. */
    var label = cfg.label && cfg.label[name];
    if (label && cfg.conversionId && typeof root.gtag === 'function') {
      root.gtag('event', 'conversion', { send_to: cfg.conversionId + '/' + label });
    } else if (!label && root.console && cfg.hinweise) {
      root.console.info('[T27] Zaehler "' + name + '" gefeuert - Conversion-Label fehlt noch (Platzhalter).');
    }
  }
  BP.zaehler = zaehler;

  function angebotsnummer() {
    var jetzt = new Date();
    var jahr = jetzt.getFullYear();
    var start = new Date(jahr, 0, 0);
    var tag = Math.floor((jetzt - start) / 86400000);            /* 1 bis 366 */
    var fenster = Math.min(9, Math.floor(jetzt.getHours() / 2.4)); /* 0 bis 9  */
    return 'BP-' + jahr + '-' + String(tag).padStart(3, '0') + fenster;
  }
  BP.angebotsnummer = angebotsnummer;

  function eingabeLesen() {
    var aufzugEl = document.querySelector('input[name="bp-aufzug"]:checked');
    var zufahrtEl = document.querySelector('input[name="bp-zufahrt"]:checked');
    var bauartEl = document.querySelector('input[name="bp-bauart"]:checked');
    return {
      ap: parseInt(el('bp-ap-anzahl').value, 10) || 0,
      paket: el('bp-paket').value,
      besprechung: el('bp-besprechung').value,
      besprechungAnzahl: parseInt(el('bp-besprechung-anzahl').value, 10) || 1,
      empfang: el('bp-empfang').value,
      schraenke: parseInt(el('bp-schraenke').value, 10) || 0,
      montage: el('bp-montage').checked,
      altAnzahl: parseInt(el('bp-alt-anzahl').value, 10) || 0,
      altBauart: bauartEl ? bauartEl.value : 'zerlegbar',
      plz: el('bp-plz').value,
      stockwerk: parseInt(el('bp-stockwerk').value, 10) || 0,
      aufzug: aufzugEl ? aufzugEl.value : 'moebel',
      zufahrt: zufahrtEl ? zufahrtEl.value : 'lkw',
      sonderwunsch: el('bp-sonderwunsch').value
    };
  }

  function textZeile(bez, wert, klasse) {
    return '<div class="bp-ap__zeile' + (klasse ? ' ' + klasse : '') + '"><span>' + bez + '</span><span>' + wert + '</span></div>';
  }

  BP.init = function () {
    var wurzel = el('bp-ap');
    if (!wurzel) { return; }
    var datenEl = el('bp-ap-daten');
    if (!datenEl) { return; }

    var d;
    try { d = JSON.parse(datenEl.textContent); }
    catch (err) { d = null; }

    var maengel = d ? BP.datenPruefen(d) : ['Die Datengrundlage konnte nicht gelesen werden.'];
    if (maengel.length) {
      el('bp-ap-fehler').innerHTML =
        '<strong>Der Angebotsplaner rechnet nicht, weil seine Datengrundlage unvollständig ist.</strong>' +
        '<p>Kein Preis ist besser als ein falscher. Bitte an die Betreuung geben:</p><ul><li>' +
        maengel.slice(0, 12).join('</li><li>') + '</li></ul>';
      el('bp-ap-fehler').hidden = false;
      el('bp-ap-formular').hidden = true;
      return;
    }

    BP.daten = d;
    var cfg = root.BP_AP_CFG || {};
    var opt = { maxSendungen: cfg.maxSendungen || 3 };
    /* Wertgrenze der Verbindlichkeit (Entscheid MO 01.09.2026, siehe Section-Kommentar) */
    var grenzeAp = cfg.grenzeAp || 19;

    /* Platzhalter im Sonderwunschfeld - wechselt bei jedem Aufruf (Spezifikation §3) */
    var sw = el('bp-sonderwunsch');
    sw.setAttribute('placeholder', PLATZHALTER[Math.floor(Math.random() * PLATZHALTER.length)]);

    /* Preise in die Paketauswahl schreiben - deutsche Schreibweise, Zeichen hinter
       der Zahl (E36). Die Zahl kommt aus bp_paket, nicht aus dem Markup.
       Zugleich: Pakete ohne Aufwandszeile werden gar nicht erst angeboten. Sie
       verschwinden aus der Auswahl, statt mit einem zu niedrigen Preis zu erscheinen. */
    BP.ohneAufwand = [];
    function auswahlAufbereiten(id, zusatz) {
      var s = el(id);
      if (!s) { return; }
      for (var a = s.options.length - 1; a >= 0; a--) {
        var wert = s.options[a].value;
        if (!wert) { continue; }
        var pk = paket(d, wert);
        if (!pk) { s.remove(a); continue; }
        if (!aufwandFuerPaket(d, pk)) {
          BP.ohneAufwand.push(pk.bezeichnung);
          s.remove(a);
          continue;
        }
        s.options[a].textContent = pk.bezeichnung + (zusatz ? ' — ' + geld(pk.preis) + zusatz : '');
      }
    }
    auswahlAufbereiten('bp-paket', ' je Arbeitsplatz');
    auswahlAufbereiten('bp-besprechung', '');
    auswahlAufbereiten('bp-empfang', '');

    var stauraum = paket(d, 'stauraum_schrank');
    if (!stauraum || !aufwandFuerPaket(d, stauraum)) {
      if (stauraum) { BP.ohneAufwand.push(stauraum.bezeichnung); }
      var sf = el('bp-schraenke');
      if (sf) { sf.value = 0; sf.closest('.bp-ap__feld').hidden = true; }
    }

    var letzterStand = null;

    function aktualisieren(vonEingabe) {
      var e = eingabeLesen();

      /* Folgefelder ein- und ausblenden */
      el('bp-alt-bauart').hidden = !(e.altAnzahl > 0);
      el('bp-aufzug-block').hidden = !(e.stockwerk >= 1);
      el('bp-besprechung-anzahl-feld').hidden = !e.besprechung;

      /* Inhalt des gewaehlten Pakets, damit die Zusammensetzung sichtbar ist */
      var pkGewaehlt = paket(d, e.paket);
      el('bp-paket-inhalt').textContent = (pkGewaehlt && pkGewaehlt.inhalt) ? pkGewaehlt.inhalt : '';

      /* Zeichenzaehler ab Zeichen 1.700 (Spezifikation §2) */
      var laenge = (e.sonderwunsch || '').length;
      var zEl = el('bp-sonderwunsch-zaehler');
      zEl.hidden = laenge < 1700;
      zEl.textContent = laenge >= 2000
        ? 'Für längere Unterlagen schicken Sie uns gern eine Datei — wir melden uns.'
        : (laenge + ' von 2.000 Zeichen');

      var erg = BP.rechne(e, d, opt);
      letzterStand = { eingabe: e, ergebnis: erg };
      BP.stand = letzterStand;

      var ausgabe = el('bp-ap-ergebnis');
      var knopf = el('bp-ap-absenden');
      var sonderPflicht = false;

      if (erg.status === 'preis') {
        var mitSonderwunsch = (e.sonderwunsch || '').trim().length > 0;
        var html = '<p class="bp-ap__preis">Ihr Preis: <strong>' + geld(erg.gesamt) + ' netto</strong>' +
          (mitSonderwunsch ? ' <span class="bp-ap__preis-zusatz">— ohne Ihre Zusatzwünsche</span>' : '') + '</p>';
        html += '<div class="bp-ap__aufteilung">' +
          textZeile('Möbel', geld(erg.moebel)) +
          textZeile('Leistungen', geld(erg.leistungen)) +
          textZeile('Fracht', geld(erg.fracht)) +
          '</div>';
        if (mitSonderwunsch) {
          html += '<p class="bp-ap__zusatz">Ihre Angaben rechnen wir ein und melden uns:<br><strong>Antwort innerhalb von 24 Stunden · Mo–Fr 8–17 Uhr</strong></p>';
        }
        if (e.ap > grenzeAp) {
          html += '<p class="bp-ap__zusatz">Ab ' + (grenzeAp + 1) + ' Arbeitsplätzen sehen wir uns Ihr Projekt persönlich an. <strong>Ihre Preisauskunft bekommen Sie sofort — der Preis ist ' + (cfg.bindefrist || 30) + ' Tage gebunden</strong>, Ihr verbindliches Angebot innerhalb von 24 Stunden.</p>';
        }
        html += '<p class="bp-ap__frist">Preis gültig ' + (cfg.bindefrist || 30) + ' Tage. Alle Preise netto zzgl. MwSt.</p>';
        if (erg.hinweise.indexOf('ueberhang_alt') !== -1) {
          html += '<p class="bp-ap__warn">Sie haben mehr Alt-Arbeitsplätze angegeben als neue. Demontage und Entsorgung rechnen wir eins zu eins; den Überhang schreiben Sie uns bitte unten ins Feld — wir weisen ihn gesondert aus.</p>';
        }
        ausgabe.innerHTML = html;
        ausgabe.className = 'bp-ap__erg bp-ap__erg--preis';
        /* „erstellen“ heisst: Sie bekommen es jetzt. „anfordern“ heisst: wir schicken es. */
        knopf.textContent = e.ap > grenzeAp ? 'Angebot anfordern' : 'Angebot erstellen';
        zaehler('rechner_abgeschlossen', { bp_ap: e.ap, bp_gebiet: erg.gebiet.zone, bp_preis: erg.gesamt });
      } else if (erg.status === 'sets') {
        ausgabe.innerHTML = '<p class="bp-ap__sperre">' + erg.text + '</p>' +
          '<p><a class="bp-ap__setlink" href="' + (cfg.setsUrl || '/collections/all') + '">Zu den Büro-Sets mit festem Preis</a></p>';
        ausgabe.className = 'bp-ap__erg bp-ap__erg--sets';
        knopf.textContent = 'Trotzdem Angebot anfordern';
        sonderPflicht = true;
      } else if (erg.status === 'anfrage') {
        ausgabe.innerHTML = '<p class="bp-ap__sperre">' + erg.text + '</p>' +
          '<p class="bp-ap__zusage"><strong>Antwort innerhalb von 24 Stunden · Mo–Fr 8–17 Uhr</strong></p>';
        ausgabe.className = 'bp-ap__erg bp-ap__erg--anfrage';
        knopf.textContent = 'Anfrage senden';
        sonderPflicht = true;
      } else if (erg.status === 'vorlaeufig') {
        /* Ä256: Moebelsumme sofort, der Festpreis kommt mit der Postleitzahl. Der
           Hinweis sagt, wo sie fehlt, und der Link fuehrt direkt in das Feld. */
        ausgabe.innerHTML = '<p class="bp-ap__preis">Möbel: <strong>' + geld(erg.moebel) + ' netto</strong></p>' +
          '<p class="bp-ap__zusatz">' + (e.montage ? 'Lieferung und Montage rechnen' : 'Die Lieferung rechnen') +
          ' wir dazu, sobald Sie die Postleitzahl des Lieferorts eingeben — dann steht hier Ihr Festpreis.<br>' +
          '<a class="bp-ap__setlink" href="#bp-plz" data-bp-zur-plz>› Postleitzahl eingeben (Schritt 5)</a></p>';
        ausgabe.className = 'bp-ap__erg bp-ap__erg--vorlaeufig';
        /* Ohne Postleitzahl entsteht eine Anfrage, kein Dokument - also „anfordern“. */
        knopf.textContent = 'Angebot anfordern';
      } else {
        ausgabe.innerHTML = '<p class="bp-ap__hinweis">' + (erg.text || 'Bitte vervollständigen Sie Ihre Angaben.') + '</p>';
        ausgabe.className = 'bp-ap__erg bp-ap__erg--offen';
        knopf.textContent = 'Angebot erstellen';
      }

      /* Bei einem D-Fall wird das Sonderwunschfeld zum Pflichtfeld (Spezifikation §4.2) */
      sw.required = sonderPflicht;
      el('bp-sonderwunsch-pflicht').hidden = !sonderPflicht;

      /* Pruefmodus: Zwischengroessen sichtbar machen (Gegenprobe am 09.09.) */
      var pm = el('bp-ap-pruefmodus');
      if (pm && cfg.pruefmodus) {
        pm.hidden = false;
        var zeilen = '';
        zeilen += textZeile('Lademeter gesamt', zahl(erg.ldm, 2));
        zeilen += textZeile('Montage-Personenstunden', zahl(erg.stunden, 1));
        zeilen += textZeile('Montagetage / Nächte', erg.tage + ' / ' + erg.naechte);
        zeilen += textZeile('Montagegebiet / Frachtzone', (erg.gebiet ? erg.gebiet.zone : '–') + ' / ' + (erg.frachtzone || '–'));
        for (var q = 0; q < erg.leistungsPositionen.length; q++) {
          zeilen += textZeile('› ' + erg.leistungsPositionen[q].bezeichnung, geld(erg.leistungsPositionen[q].betrag), 'bp-ap__zeile--klein');
        }
        for (var w = 0; w < erg.frachtPositionen.length; w++) {
          zeilen += textZeile('› ' + erg.frachtPositionen[w].bezeichnung, geld(erg.frachtPositionen[w].betrag), 'bp-ap__zeile--klein');
        }
        if (BP.ohneAufwand && BP.ohneAufwand.length) {
          zeilen += textZeile('⚠ nicht angeboten, weil die Aufwandszeile fehlt', BP.ohneAufwand.join(' · '), 'bp-ap__zeile--klein');
        }
        pm.innerHTML = '<p class="bp-ap__pm-titel">Prüfmodus — Zwischengrößen</p>' + zeilen;
      }

      /* Rechnerwerte in die Anfrage schreiben */
      BP.formularFuellen(e, erg);

      if (vonEingabe) { zaehler('rechner_gestartet', {}); }
    }

    BP.formularFuellen = function (e, erg) {
      function setz(id, wert) { var x = el(id); if (x) { x.value = wert; } }
      var pk = paket(d, e.paket);
      var bs = e.besprechung ? paket(d, e.besprechung) : null;
      var ef = e.empfang ? paket(d, e.empfang) : null;
      setz('bp-f-ap', e.ap);
      setz('bp-f-dokumentart', erg.status === 'preis'
        ? (e.ap > grenzeAp ? 'Preisauskunft — verbindliches Angebot nach Prüfung' : 'Angebot, verbindlich')
        : 'Anfrage ohne Sofortpreis');
      setz('bp-f-paket', pk ? pk.bezeichnung : '');
      setz('bp-f-zusatz', [
        bs ? (e.besprechungAnzahl + ' × ' + bs.bezeichnung) : '',
        ef ? ef.bezeichnung : '',
        e.schraenke > 0 ? (e.schraenke + ' × Stauraum-Schrank') : ''
      ].filter(Boolean).join(' · ') || 'keine');
      setz('bp-f-leistungen', e.montage ? 'Lieferung und Montage' + (e.altAnzahl > 0 ? ', Demontage und Entsorgung' : '') : 'nur Lieferung');
      setz('bp-f-alt', e.altAnzahl > 0 ? (e.altAnzahl + ' Alt-Arbeitsplätze, ' + (e.altBauart === 'massiv' ? 'massive / nicht zerlegbare Bauart' : 'zerlegbare Bauart')) : 'keine');
      setz('bp-f-zugang', e.stockwerk === 0 ? 'ebenerdig / Erdgeschoss'
        : (e.stockwerk + '. Obergeschoss, ' + ({ moebel: 'möbeltauglicher Aufzug', person: 'Aufzug nur für Personen', kein: 'kein Aufzug' }[e.aufzug] || '')));
      setz('bp-f-zufahrt', { lkw: 'LKW-Zufahrt bis 30 m', eng: 'eingeschränkt — Kleinfahrzeug oder langer Tragweg', fuss: 'Fußgängerzone / Halteverbotszone / festes Lieferfenster' }[e.zufahrt]);
      setz('bp-f-gebiet', erg.gebiet ? (erg.gebiet.bezeichnungKurz + ' (Montagegebiet ' + erg.gebiet.zone + ', Frachtzone ' + erg.frachtzone + ')') : '');
      setz('bp-f-aufwand', erg.status === 'preis'
        ? (zahl(erg.ldm, 2) + ' Lademeter · ' + zahl(erg.stunden, 1) + ' Personenstunden · ' +
           erg.tage + (erg.tage === 1 ? ' Montagetag' : ' Montagetage'))
        : '');
      setz('bp-f-preis', erg.status === 'preis'
        ? (geld(erg.gesamt) + ' netto (Möbel ' + geld(erg.moebel) + ' · Leistungen ' + geld(erg.leistungen) + ' · Fracht ' + geld(erg.fracht) + ')')
        : (erg.status === 'vorlaeufig'
            ? ('kein Sofortpreis — Möbel ' + geld(erg.moebel) + ' netto, ohne Leistungen und Fracht (PLZ fehlt)')
            : ('kein Sofortpreis — ' + (erg.grund || 'unvollständig'))));
      var plzEl = el('bp-f-plz'); if (plzEl) { plzEl.value = e.plz; }
      var swEl = el('bp-f-sonderwunsch'); if (swEl) { swEl.value = e.sonderwunsch; }
    };

    /* Ereignisse */
    var felder = wurzel.querySelectorAll('input, select, textarea');
    for (var i = 0; i < felder.length; i++) {
      felder[i].addEventListener('input', function () { aktualisieren(true); });
      felder[i].addEventListener('change', function () { aktualisieren(true); });
    }

    /* Vor dem Absenden: Angebotsnummer vergeben und Stand sichern, damit die
       Bestaetigungsseite dasselbe Dokument zeigt, das bei uns ankommt. */
    var form = el('bp-ap-anfrage-form');
    if (form) {
      form.addEventListener('submit', function (ev) {
        /* Bei einem D-Fall ist das Sonderwunschfeld Pflicht. Es steht ausserhalb
           des Formulars, deshalb wird hier geprueft und nicht ueber required. */
        if (sw.required && !(sw.value || '').trim()) {
          ev.preventDefault();
          el('bp-sonderwunsch-pflicht').classList.add('bp-ap__pflicht--aktiv');
          sw.focus();
          sw.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }
        var nr = angebotsnummer();
        var nrEl = el('bp-f-nummer'); if (nrEl) { nrEl.value = nr; }
        try {
          sessionStorage.setItem('bp_t27_stand', JSON.stringify({
            nummer: nr, zeit: new Date().toISOString(),
            eingabe: letzterStand ? letzterStand.eingabe : null,
            ergebnis: letzterStand ? letzterStand.ergebnis : null,
            /* Die Angaben in Klartext MUESSEN hier mitgesichert werden. Nach dem
               Absenden laedt die Seite neu; die Formularfelder stehen dann wieder
               auf ihren Voreinstellungen. Wer sie erst auf der Bestaetigungsseite
               ausliest, schreibt dem Kunden fremde Angaben ins Angebot. */
            angaben: {
              paket: (el('bp-f-paket') || {}).value, zusatz: (el('bp-f-zusatz') || {}).value,
              leistungen: (el('bp-f-leistungen') || {}).value, alt: (el('bp-f-alt') || {}).value,
              zugang: (el('bp-f-zugang') || {}).value, zufahrt: (el('bp-f-zufahrt') || {}).value,
              gebiet: (el('bp-f-gebiet') || {}).value, aufwand: (el('bp-f-aufwand') || {}).value
            },
            kontakt: {
              firma: (el('bp-k-firma') || {}).value, name: (el('bp-k-name') || {}).value,
              email: (el('bp-k-mail') || {}).value, telefon: (el('bp-k-tel') || {}).value
            }
          }));
        } catch (err) { /* kein Blocker */ }
      });
    }

    /* Ä256: Der Link im vorlaeufigen Preis fuehrt direkt in das Postleitzahlfeld.
       Die Ausgabe wird bei jeder Eingabe neu geschrieben, deshalb haengt der Klick
       an der Ausgabe und nicht am Link selbst. */
    var ausgabeEl = el('bp-ap-ergebnis');
    if (ausgabeEl) {
      ausgabeEl.addEventListener('click', function (ev) {
        var ziel = ev.target && ev.target.closest ? ev.target.closest('[data-bp-zur-plz]') : null;
        if (!ziel) { return; }
        ev.preventDefault();
        var plzFeld = el('bp-plz');
        if (!plzFeld) { return; }
        plzFeld.scrollIntoView({ behavior: 'smooth', block: 'center' });
        try { plzFeld.focus({ preventScroll: true }); } catch (err) { plzFeld.focus(); }
      });
    }

    aktualisieren(false);
    BP.bestaetigungPruefen();
  };

  /* Nach der Rueckkehr mit contact_posted=true: Zaehler 3 und das Angebot. */
  BP.bestaetigungPruefen = function () {
    if (window.location.search.indexOf('contact_posted=true') === -1) { return; }
    var box = el('bp-ap-bestaetigung');
    if (!box) { return; }
    var stand = null;
    try { stand = JSON.parse(sessionStorage.getItem('bp_t27_stand')); } catch (e) { stand = null; }
    var cfg = root.BP_AP_CFG || {};
    var grenze = cfg.grenzeAp || 19;
    var ap = (stand && stand.eingabe && stand.eingabe.ap) || 0;
    var verbindlich = ap > 0 && ap <= grenze;

    box.hidden = false;
    var nr = stand && stand.nummer ? stand.nummer : '—';
    el('bp-ap-nummer').textContent = nr;
    zaehler('angebot_angefordert', { bp_angebotsnummer: nr, bp_ap: ap, bp_verbindlich: verbindlich });

    if (stand && stand.ergebnis && stand.ergebnis.status === 'preis') {
      var knopf = el('bp-ap-angebot-knopf');
      var zusatz = el('bp-ap-best-zusatz');
      knopf.textContent = verbindlich
        ? 'Angebot als PDF herunterladen'
        : 'Preisauskunft als PDF herunterladen';
      knopf.hidden = false;
      knopf.addEventListener('click', function () { BP.angebotPdf(stand); });

      /* Zweiter Weg, klein daneben: das Dokument im Fenster ansehen und von dort
         drucken. Wird hier erzeugt und nicht in der Section angelegt, damit die
         Section unveraendert bleibt. */
      if (!el('bp-ap-ansehen')) {
        var link = document.createElement('button');
        link.type = 'button';
        link.id = 'bp-ap-ansehen';
        link.className = 'bp-ap__nebenlink';
        link.textContent = 'Lieber im Fenster ansehen';
        link.style.cssText = 'background:none;border:0;padding:6px 2px;margin-left:14px;' +
          'font:inherit;font-size:.92em;color:#00527A;text-decoration:underline;cursor:pointer;';
        link.addEventListener('click', function () { BP.angebotDrucken(stand); });
        if (knopf.parentNode) { knopf.parentNode.insertBefore(link, knopf.nextSibling); }
      }
      if (!verbindlich && zusatz) {
        zusatz.innerHTML = 'Ab ' + (grenze + 1) + ' Arbeitsplätzen sehen wir uns Ihr Projekt persönlich an. ' +
          '<strong>Ihre Preisauskunft können Sie sofort speichern — der genannte Preis ist ' +
          (cfg.bindefrist || 30) + ' Tage gebunden.</strong> Ihr verbindliches Angebot senden wir Ihnen danach zu.';
        zusatz.hidden = false;
      }
    }
    box.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  /* Das Angebot: ein Dokument, eine Nummer (Ablauf §2 und §4). */
  BP.angebotDrucken = function (stand) {
    var cfg = root.BP_AP_CFG || {};
    var e = stand.eingabe, g = stand.ergebnis, k = stand.kontakt || {};
    var heute = stand.zeit ? new Date(stand.zeit) : new Date();
    var bis = new Date(heute.getTime() + (cfg.bindefrist || 30) * 86400000);

    /* Zwei Dokumentarten, geteilt an der Wertgrenze (Entscheid MO 01.09.2026):
       bis zur Grenze ein Angebot, das mit der Bestaetigung des Kunden zum Vertrag
       wird (AGB § 2 Abs. 5); darueber eine Preisauskunft mit derselben
       30-Tage-Preisbindung, aber ohne automatische Bindung an den Abschluss.
       Die Verkaufsaussage - der Preis steht - ist in beiden Faellen dieselbe. */
    var verbindlich = (e.ap || 0) <= (cfg.grenzeAp || 19);
    var art = verbindlich ? 'Angebot' : 'Preisauskunft';

    /* Shopifys image_url liefert die Adresse OHNE Protokoll ("//cdn.shopify.com/...").
       Auf einer normalen Seite ergaenzt der Browser das Protokoll der Seite; in dem
       Blob-Fenster, in dem dieses Dokument liegt, gibt es keines - die Adresse zeigt
       dann ins Leere und das Logo bleibt ein leerer Kasten (Befund MO, 02.09.2026).
       Deshalb hier ausdruecklich https voranstellen. */
    var logoSrc = cfg.logoUrl || '';
    if (logoSrc.indexOf('//') === 0) { logoSrc = 'https:' + logoSrc; }
    function dat(x) { return String(x.getDate()).padStart(2, '0') + '.' + String(x.getMonth() + 1).padStart(2, '0') + '.' + x.getFullYear(); }
    function reihe(b, m, ez, be) {
      return '<tr><td>' + b + '</td><td class="r">' + (m || '') + '</td><td class="r">' + (ez ? geld(ez) : '') + '</td><td class="r">' + geld(be) + '</td></tr>';
    }
    var zeilen = '';
    zeilen += '<tr class="gr"><td colspan="4">Möbel</td></tr>';
    for (var i = 0; i < g.moebelPositionen.length; i++) {
      var m = g.moebelPositionen[i];
      zeilen += reihe(m.bezeichnung, m.menge, m.einzel, m.betrag);
    }
    zeilen += '<tr class="gr"><td colspan="4">Lieferung</td></tr>';
    for (var j = 0; j < g.frachtPositionen.length; j++) {
      zeilen += reihe(g.frachtPositionen[j].bezeichnung, '', '', g.frachtPositionen[j].betrag);
    }
    zeilen += '<tr class="gr"><td colspan="4">Montage und Altmöbel</td></tr>';
    for (var l = 0; l < g.leistungsPositionen.length; l++) {
      var p = g.leistungsPositionen[l];
      zeilen += reihe(p.bezeichnung + (p.zusatz ? ' <span class="kl">(' + p.zusatz + ')</span>' : ''), '', '', p.betrag);
    }
    var netto = g.gesamt, ust = netto * 0.19;
    /* Die Angaben kommen aus dem gesicherten Stand, nicht aus den Formularfeldern:
       nach dem Absenden stehen die wieder auf ihren Voreinstellungen. */
    var a = stand.angaben || {};
    var angaben = [
      ['Arbeitsplätze', e.ap + ' × ' + (a.paket || '')],
      ['Zusatzbereiche', a.zusatz || 'keine'],
      ['Leistungen', a.leistungen || ''],
      ['Altmöbel', a.alt || 'keine'],
      ['Zugang', a.zugang || ''],
      ['Zufahrt', a.zufahrt || ''],
      ['Lieferort', e.plz + ' — ' + (a.gebiet || '')]
    ];
    var angabenHtml = angaben.map(function (a) { return '<tr><td>' + a[0] + '</td><td>' + (a[1] || '') + '</td></tr>'; }).join('');
    var sonder = (e.sonderwunsch || '').trim();

    var doc = '<!doctype html><html lang="de"><head><meta charset="utf-8"><title>' + art + ' ' + stand.nummer + '</title><style>' +
      'body{font-family:"DM Sans",Helvetica,Arial,sans-serif;color:#1A1A1A;font-size:11pt;line-height:1.5;margin:22mm 18mm;}' +
      'h1{font-size:16pt;color:#00304A;margin:0 0 2mm;}h2{font-size:11.5pt;color:#00304A;margin:7mm 0 2mm;}' +
      '.kopf{display:flex;justify-content:space-between;align-items:flex-start;border-bottom:2px solid #00527A;padding-bottom:4mm;}' +
      '.wort{font-size:15pt;font-weight:800;color:#00527A;letter-spacing:.02em;}' +
      '.wort small{display:block;font-size:8pt;font-weight:400;letter-spacing:.18em;color:#55666C;text-transform:uppercase;}' +
      '.logo{height:' + (cfg.logoHoehe || 20) + 'mm;width:auto;display:block;}' +
      '.kenn{font-size:9.5pt;text-align:right;color:#33474F;}' +
      'table{width:100%;border-collapse:collapse;margin-top:2mm;}' +
      'td,th{padding:1.6mm 2mm;border-bottom:1px solid #E3E9EA;vertical-align:top;font-size:10pt;}' +
      '.r{text-align:right;white-space:nowrap;}.gr td{background:#F2F6F7;font-weight:700;color:#00304A;}' +
      '.kl{color:#7A888D;font-size:8.5pt;}' +
      '.summe td{font-weight:700;}.summe .gesamt{font-size:12pt;color:#00304A;}' +
      'p{margin:0 0 2.5mm;}.klein{font-size:9pt;color:#33474F;}' +
      '.fuss{margin-top:8mm;border-top:1px solid #C9D6DA;padding-top:3mm;font-size:8pt;color:#55666C;display:flex;gap:6mm;}' +
      '.fuss div{flex:1;}@media print{body{margin:14mm;}}' +
      '.leiste{background:#00527A;color:#fff;padding:3mm 4mm;margin:0 0 6mm;border-radius:3px;display:flex;justify-content:space-between;align-items:center;gap:5mm;font-size:9.5pt;}' +
      '.leiste button{background:#fff;color:#00527A;border:0;border-radius:3px;padding:2.5mm 5mm;font:inherit;font-weight:700;cursor:pointer;white-space:nowrap;}' +
      '@media print{.leiste{display:none !important;}}' +
      /* Der Kopf ist ein Flex-Kasten; ohne diese Zeile stellt sich die Marke in
         manchen Browsern neben statt ueber den Rueckfall-Schriftzug. */
      '.marke{display:block;}' +
      '</style></head><body>' +
      /* Bedienleiste: nur am Bildschirm, nie im Ausdruck. Sie ist der Ersatz dafür,
         dass der Druckdialog je nach Browser nicht von selbst aufgeht. */
      '<div class="leiste"><span><strong>Ihr ' + art + ' ' + stand.nummer + '.</strong> ' +
      'Zum Speichern: Drucken → „Als PDF sichern“.</span>' +
      '<button type="button" onclick="window.print()">Drucken / Als PDF speichern</button></div>' +
      '<div class="kopf"><div class="marke">' +
      /* Logo aus den Section-Einstellungen. Das gesetzte Wortbild steht als Rueckfall
         darunter und wird eingeblendet, wenn das Bild nicht laedt - ein leerer Kasten
         im Angebot ist schlimmer als ein Schriftzug. */
      (logoSrc ? '<img class="logo" src="' + logoSrc + '" alt="büro project — Furniture for work">' : '') +
      '<div class="wort" id="bp-wort"' + (logoSrc ? ' style="display:none"' : '') +
      '>büro Project<small>Furniture for work</small></div></div>' +
      '<div class="kenn"><strong>' + art + ' ' + stand.nummer + '</strong><br>Datum ' + dat(heute) +
      '<br>' + (verbindlich ? 'gültig bis ' : 'Preis gültig bis ') + dat(bis) +
      '<br>USt-IdNr. ' + (cfg.ustid || '') + '</div></div>' +
      '<p style="margin-top:6mm">' + (k.firma || '') + '<br>' + (k.name || '') + '<br>' + (k.email || '') + '</p>' +
      '<h1>' + (verbindlich ? 'Ihr Angebot für ' : 'Ihre Preisauskunft für ') + e.ap + ' Arbeitsplätze</h1>' +
      '<p class="klein">' + (verbindlich
        ? 'Vielen Dank für Ihre Anfrage. Auf Grundlage Ihrer Angaben bieten wir Ihnen an:'
        : 'Vielen Dank für Ihre Anfrage. Auf Grundlage Ihrer Angaben rechnen wir wie folgt. Ihr verbindliches Angebot senden wir Ihnen nach persönlicher Prüfung innerhalb von 24 Stunden zu.') + '</p>' +
      '<table><thead><tr><th>Position</th><th class="r">Menge</th><th class="r">Einzelpreis</th><th class="r">Gesamt</th></tr></thead>' +
      '<tbody>' + zeilen +
      '<tr class="summe"><td colspan="3" class="r">Summe netto</td><td class="r gesamt">' + geld(netto) + '</td></tr>' +
      '<tr class="summe"><td colspan="3" class="r">zzgl. 19 % USt.</td><td class="r">' + geld(ust) + '</td></tr>' +
      '<tr class="summe"><td colspan="3" class="r">Gesamtbetrag brutto</td><td class="r">' + geld(netto + ust) + '</td></tr>' +
      '</tbody></table>' +
      '<h2>Ihre Angaben — Grundlage ' + (verbindlich ? 'dieses Angebots' : 'dieser Preisauskunft') + '</h2><table>' + angabenHtml +
      (sonder ? '<tr><td>Ihre Zusatzwünsche</td><td>' + sonder.replace(/</g, '&lt;').replace(/\n/g, '<br>') + '</td></tr>' : '') +
      '</table>' +
      '<h2>Leistungsumfang und Voraussetzungen</h2><div class="klein">' + (cfg.voraussetzungen || '') + '</div>' +
      '<h2>Grundlage und Anpassung</h2><div class="klein">' +
      ((verbindlich ? cfg.anpassung : cfg.anpassungAuskunft) || cfg.anpassung || '') + '</div>' +
      '<h2>' + (verbindlich ? 'Annahme, Zahlung und Geltung' : 'Preisbindung, Zahlung und Geltung') + '</h2><div class="klein">' +
      ((verbindlich ? cfg.annahme : cfg.annahmeAuskunft) || cfg.annahme || '') + '</div>' +
      '<div class="fuss"><div>' + (cfg.firma || '') + '<br>' + (cfg.anschrift || '') + '</div>' +
      '<div>' + (cfg.kontakt || '') + '</div><div>' + (cfg.register || '') + '</div></div>' +
      /* KEIN Selbstdruck. Das Dokument soll erst dastehen; gedruckt wird ueber den
         Knopf in der Leiste (Befund MO, 02.09.2026 - der Dialog ging sofort auf und
         verdeckte das Dokument). Das Skript hier faengt nur den Fall ab, dass das
         Logo nicht laedt: dann tritt das gesetzte Wortbild an seine Stelle. */
      '<script>(function(){var i=document.querySelector("img.logo");' +
      'var w=document.getElementById("bp-wort");if(!i){return;}' +
      'function zeige(){i.style.display="none";if(w){w.style.display="block";}}' +
      'if(i.complete&&i.naturalWidth===0){zeige();}' +
      'i.addEventListener("error",zeige);})();<\/script>' +
      '</body></html>';

    /* Als Blob-Adresse oeffnen statt per document.write in ein about:blank zu
       schreiben. Das Fenster laedt damit ein echtes Dokument, und der Druckdialog
       haengt nicht mehr an einer Zeitschaltung von aussen. */
    var url;
    try {
      url = URL.createObjectURL(new Blob([doc], { type: 'text/html;charset=utf-8' }));
    } catch (err) { url = null; }

    var w = url ? window.open(url, '_blank') : null;
    zaehler('angebot_pdf', { bp_angebotsnummer: stand.nummer, bp_dokumentart: art, bp_ap: e.ap });

    if (!w) {
      /* Fenster blockiert oder Blob nicht moeglich: einen anklickbaren Weg anbieten,
         statt den Nutzer mit einer Warnmeldung stehen zu lassen. */
      var hinweis = el('bp-ap-best-zusatz');
      if (hinweis && url) {
        hinweis.innerHTML = 'Ihr Browser hat das neue Fenster blockiert. ' +
          '<a href="' + url + '" target="_blank" rel="noopener"><strong>' + art + ' ' +
          stand.nummer + ' hier öffnen</strong></a> — im Fenster dann Drucken und „Als PDF sichern“ wählen.';
        hinweis.hidden = false;
      } else if (hinweis) {
        hinweis.textContent = 'Ihr Browser konnte das Dokument nicht öffnen. Rufen Sie uns an: 02872 80080 — wir schicken es Ihnen zu.';
        hinweis.hidden = false;
      }
      return;
    }

    try { w.focus(); } catch (err) { /* kein Blocker */ }
    /* Die Adresse muss leben, solange das Fenster sie braucht. */
    setTimeout(function () { try { URL.revokeObjectURL(url); } catch (err) {} }, 120000);
  };

  /* ------------------------------------------------------------------ */
  /* 4 - Das PDF                                                          */
  /* Ein Browser kann von sich aus keine PDF-Datei schreiben; er kann nur */
  /* drucken. Damit der Kunde eine echte Datei bekommt (Entscheid MO,     */
  /* 02.09.2026), setzt der Planer das Dokument mit jsPDF selbst - Text   */
  /* als Text, nicht als Bild, also durchsuchbar und scharf im Druck.     */
  /* Die Bibliothek wird ERST beim Klick nachgeladen: die Seite selbst    */
  /* bleibt so leicht wie vorher. Laedt sie nicht, faellt der Knopf auf   */
  /* das Fenster mit Druckknopf zurueck - der Kunde steht nie ohne da.    */
  /* ------------------------------------------------------------------ */

  var JSPDF_QUELLE = 'https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js';

  /* Rich Text aus den Metaobjekten in reinen Text. Kein DOM noetig, damit
     dieselbe Funktion in Node geprueft werden kann. */
  function nurText(html, basis) {
    var t = String(html == null ? '' : html);
    /* Ein Link verliert im PDF sein Ziel. Im Angebot steht aber „es gelten unsere
       AGB" - der Kunde muss sie finden koennen, ohne den Shop zu durchsuchen.
       Deshalb wandert die Adresse in Klammern hinter den Linktext. */
    t = t.replace(/<a[^>]*href\s*=\s*["']([^"']+)["'][^>]*>([\s\S]*?)<\/a>/gi, function (ganz, ziel, text) {
      var z = String(ziel).replace(/^https?:\/\//, '');
      if (z.indexOf('/') === 0 && basis) { z = String(basis).replace(/^https?:\/\//, '').replace(/\/$/, '') + z; }
      var reiner = String(text).replace(/<[^>]*>/g, '').trim();
      return z && z.indexOf('#') !== 0 ? reiner + ' (' + z + ')' : reiner;
    });
    t = t.replace(/<\s*br\s*\/?\s*>/gi, '\n');
    t = t.replace(/<\s*li[^>]*>/gi, '\n• ');
    t = t.replace(/<\s*\/\s*(p|div|li|h[1-6]|ul|ol)\s*>/gi, '\n');
    t = t.replace(/<[^>]*>/g, '');
    t = t.replace(/&nbsp;/g, ' ').replace(/&lt;/g, '<').replace(/&gt;/g, '>')
      .replace(/&quot;/g, '"').replace(/&#39;/g, "'").replace(/&euro;/g, '€')
      .replace(/&ndash;/g, '–').replace(/&mdash;/g, '—')
      .replace(/&bdquo;/g, '„').replace(/&ldquo;/g, '“').replace(/&sect;/g, '§')
      .replace(/&amp;/g, '&');
    t = t.replace(/[ \t]+/g, ' ').replace(/ *\n */g, '\n').replace(/\n{3,}/g, '\n\n');
    return t.trim();
  }
  BP.nurText = nurText;

  /* Baut das Dokument. Bewusst ohne Browser-Bezug, damit die Pruefung in Node
     dieselbe Datei erzeugt, die der Kunde bekommt. */
  BP.pdfBauen = function (stand, jsPDF, logo, cfg) {
    cfg = cfg || (root.BP_AP_CFG || {});
    var e = stand.eingabe, g = stand.ergebnis, k = stand.kontakt || {};
    var heute = stand.zeit ? new Date(stand.zeit) : new Date();
    var bis = new Date(heute.getTime() + (cfg.bindefrist || 30) * 86400000);
    var verbindlich = (e.ap || 0) <= (cfg.grenzeAp || 19);
    var art = verbindlich ? 'Angebot' : 'Preisauskunft';

    var doc = new jsPDF({ unit: 'mm', format: 'a4', orientation: 'portrait', compress: true });
    var L = 18, R = 192, BREITE = R - L, UNTEN = 268;
    var TINTE = [26, 26, 26], DUNKEL = [0, 48, 74], BLAU = [0, 82, 122], GRAU = [85, 102, 108];
    var y = 0;

    function asc(pt) { return pt * 0.3528 * 0.82; }
    function lh(pt) { return pt * 0.3528 * 1.34; }
    function stil(pt, fett, farbe) {
      doc.setFont('helvetica', fett ? 'bold' : 'normal');
      doc.setFontSize(pt);
      var f = farbe || TINTE;
      doc.setTextColor(f[0], f[1], f[2]);
    }
    function dat(x) {
      return String(x.getDate()).padStart(2, '0') + '.' + String(x.getMonth() + 1).padStart(2, '0') + '.' + x.getFullYear();
    }

    function folgekopf() {
      stil(8, false, GRAU);
      doc.text(art + ' ' + stand.nummer, L, 14 + asc(8));
      doc.setDrawColor(201, 214, 218); doc.setLineWidth(0.2);
      doc.line(L, 19, R, 19);
      return 26;
    }
    function platz(hoehe) {
      if (y + (hoehe || 0) > UNTEN) { doc.addPage(); y = folgekopf(); return true; }
      return false;
    }
    function absatz(text, pt, fett, farbe, abstand, breite, x) {
      /* Erst die Schrift setzen, dann umbrechen: splitTextToSize misst mit der
         Schrift, die GERADE gilt. Wer zuerst umbricht, bricht mit der Schrift der
         vorigen Zeile um - dann steht ein 8,5-Punkt-Absatz im Umbruch einer
         11,5-Punkt-Ueberschrift und franst mitten im Satz aus. */
      stil(pt, fett, farbe);
      var zeilen = doc.splitTextToSize(String(text == null ? '' : text), breite || BREITE);
      for (var i = 0; i < zeilen.length; i++) {
        platz(lh(pt));
        stil(pt, fett, farbe);
        doc.text(zeilen[i], x || L, y + asc(pt));
        y += lh(pt);
      }
      y += (abstand == null ? 1.4 : abstand);
    }
    /* Eine Ueberschrift wandert mit, wenn unter ihr nicht mindestens drei Zeilen
       Platz haben - sonst steht sie allein am Seitenfuss. */
    function ueberschrift(text) {
      y += 3.4;
      platz(lh(11.5) + 3 * lh(8.5) + 2);
      absatz(text, 11.5, true, DUNKEL, 1.2);
    }
    /* Eine Tabellenzeile. Spalte 0 laeuft um, die drei Zahlenspalten stehen rechtsbuendig. */
    function zeile(sp, opt) {
      opt = opt || {};
      var pt = opt.pt || 9;
      var b0 = opt.breite0 || 90;
      stil(pt, !!opt.fett, opt.farbe || TINTE);   /* messen mit der Schrift dieser Zeile */
      var zeilen = doc.splitTextToSize(String(sp[0] == null ? '' : sp[0]), b0);
      var hoehe = zeilen.length * lh(pt) + 1.8;
      platz(hoehe);
      if (opt.grund) {
        doc.setFillColor(242, 246, 247);
        doc.rect(L, y, BREITE, hoehe, 'F');
      }
      stil(pt, !!opt.fett, opt.farbe || TINTE);
      for (var i = 0; i < zeilen.length; i++) {
        doc.text(zeilen[i], L + (opt.grund ? 1.5 : 0), y + 0.9 + asc(pt) + i * lh(pt));
      }
      var basis = y + 0.9 + asc(pt);
      if (sp[1] != null && sp[1] !== '') { doc.text(String(sp[1]), opt.x1 || 132, basis, { align: 'right' }); }
      if (sp[2] != null && sp[2] !== '') { doc.text(String(sp[2]), opt.x2 || 160, basis, { align: 'right' }); }
      if (sp[3] != null && sp[3] !== '') { doc.text(String(sp[3]), R, basis, { align: 'right' }); }
      y += hoehe;
      if (opt.linie !== false) {
        doc.setDrawColor(227, 233, 234); doc.setLineWidth(0.15);
        doc.line(L, y, R, y);
      }
    }
    /* Zweispaltige Angabenzeile: links die Frage, rechts die Antwort des Kunden. */
    function angabe(bez, wert) {
      var pt = 9;
      stil(pt, false, TINTE);                      /* messen mit der Schrift dieser Zeile */
      var zeilen = doc.splitTextToSize(String(wert == null ? '' : wert), R - 70);
      var hoehe = Math.max(zeilen.length, 1) * lh(pt) + 1.8;
      platz(hoehe);
      stil(pt, false, GRAU);
      doc.text(String(bez), L, y + 0.9 + asc(pt));
      stil(pt, false, TINTE);
      for (var i = 0; i < zeilen.length; i++) { doc.text(zeilen[i], 70, y + 0.9 + asc(pt) + i * lh(pt)); }
      y += hoehe;
      doc.setDrawColor(227, 233, 234); doc.setLineWidth(0.15);
      doc.line(L, y, R, y);
    }

    doc.setProperties({
      title: art + ' ' + stand.nummer,
      subject: art + ' über ' + e.ap + ' Arbeitsplätze',
      author: cfg.firma || 'büro project',
      creator: 'buero-project.de – Sofortpreis-Rechner'
    });

    /* ---- Kopf der ersten Seite ---- */
    y = 16;
    var kopfHoehe = 22;   /* Hoehe des Markenblocks; die Linie richtet sich danach */
    if (logo && logo.daten && logo.breite && logo.hoehe) {
      var h = cfg.logoHoehe || 20;
      var b = h * (logo.breite / logo.hoehe);
      if (b > 70) { b = 70; h = b * (logo.hoehe / logo.breite); }
      try { doc.addImage(logo.daten, 'PNG', L, y, b, h); kopfHoehe = h; } catch (err) { logo = null; }
    }
    if (!logo || !logo.daten) {
      kopfHoehe = 12;
      stil(15, true, BLAU);
      doc.text('büro Project', L, y + asc(15));
      doc.setCharSpace(0.7);
      stil(7.5, false, GRAU);
      doc.text('FURNITURE FOR WORK', L, y + asc(15) + 4.6);
      doc.setCharSpace(0);
    }
    var kenn = [
      { t: art + ' ' + stand.nummer, fett: true },
      { t: 'Datum ' + dat(heute) },
      { t: (verbindlich ? 'gültig bis ' : 'Preis gültig bis ') + dat(bis) },
      { t: 'USt-IdNr. ' + (cfg.ustid || '') }
    ];
    for (var kk = 0; kk < kenn.length; kk++) {
      stil(9, !!kenn[kk].fett, kenn[kk].fett ? DUNKEL : [51, 71, 79]);
      doc.text(kenn[kk].t, R, 16 + asc(9) + kk * 4.4, { align: 'right' });
    }
    /* Die Linie richtet sich nach dem Hoeheren von beidem - Marke oder Kennblock.
       Ein fester Wert liesse ein grosses Logo in die Linie laufen. */
    var linie = Math.max(38, 16 + kopfHoehe + 3, 16 + kenn.length * 4.4 + 1);
    doc.setDrawColor(BLAU[0], BLAU[1], BLAU[2]); doc.setLineWidth(0.7);
    doc.line(L, linie, R, linie);
    y = linie + 8;

    /* ---- Empfaenger, Titel, Anschreiben ---- */
    absatz([k.firma, k.name, k.email].filter(Boolean).join('\n'), 10, false, TINTE, 4);
    absatz((verbindlich ? 'Ihr Angebot für ' : 'Ihre Preisauskunft für ') + e.ap + ' Arbeitsplätze',
      15, true, DUNKEL, 1.8);
    absatz(verbindlich
      ? 'Vielen Dank für Ihre Anfrage. Auf Grundlage Ihrer Angaben bieten wir Ihnen an:'
      : 'Vielen Dank für Ihre Anfrage. Auf Grundlage Ihrer Angaben rechnen wir wie folgt. Ihr verbindliches Angebot senden wir Ihnen nach persönlicher Prüfung innerhalb von 24 Stunden zu.',
      9, false, [51, 71, 79], 3.5);

    /* ---- Positionen ---- */
    zeile(['Position', 'Menge', 'Einzelpreis', 'Gesamt'], { fett: true, pt: 8.5, farbe: DUNKEL });
    zeile(['Möbel'], { grund: true, fett: true, pt: 9, farbe: DUNKEL });
    for (var i = 0; i < g.moebelPositionen.length; i++) {
      var m = g.moebelPositionen[i];
      zeile([m.bezeichnung, m.menge, geld(m.einzel), geld(m.betrag)]);
    }
    zeile(['Lieferung'], { grund: true, fett: true, pt: 9, farbe: DUNKEL });
    for (var j = 0; j < g.frachtPositionen.length; j++) {
      zeile([g.frachtPositionen[j].bezeichnung, '', '', geld(g.frachtPositionen[j].betrag)]);
    }
    zeile(['Montage und Altmöbel'], { grund: true, fett: true, pt: 9, farbe: DUNKEL });
    for (var l = 0; l < g.leistungsPositionen.length; l++) {
      var p = g.leistungsPositionen[l];
      zeile([p.bezeichnung + (p.zusatz ? ' (' + p.zusatz + ')' : ''), '', '', geld(p.betrag)]);
    }

    var netto = g.gesamt, ust = netto * 0.19;
    y += 1.2;
    zeile(['Summe netto', '', '', geld(netto)], { fett: true, pt: 10.5, farbe: DUNKEL, breite0: 120 });
    zeile(['zzgl. 19 % USt.', '', '', geld(ust)], { pt: 9, breite0: 120 });
    zeile(['Gesamtbetrag brutto', '', '', geld(netto + ust)], { fett: true, pt: 9.5, breite0: 120 });

    /* ---- Angaben des Kunden ---- */
    ueberschrift('Ihre Angaben — Grundlage ' + (verbindlich ? 'dieses Angebots' : 'dieser Preisauskunft'));
    var a = stand.angaben || {};
    angabe('Arbeitsplätze', e.ap + ' × ' + (a.paket || ''));
    angabe('Zusatzbereiche', a.zusatz || 'keine');
    angabe('Leistungen', a.leistungen || '');
    angabe('Altmöbel', a.alt || 'keine');
    angabe('Zugang', a.zugang || '');
    angabe('Zufahrt', a.zufahrt || '');
    angabe('Lieferort', e.plz + ' — ' + (a.gebiet || ''));
    var sonder = (e.sonderwunsch || '').trim();
    if (sonder) { angabe('Ihre Zusatzwünsche', sonder); }

    /* ---- Rechtliches: dieselben Texte wie im Fenster, aus den Metaobjekten ---- */
    var basis = cfg.basis || (typeof root.location !== 'undefined' && root.location ? root.location.origin : '');
    function block(titel, html) {
      var t = nurText(html, basis);
      if (!t) { return; }
      ueberschrift(titel);
      var teile = t.split('\n');
      for (var q = 0; q < teile.length; q++) {
        if (!teile[q].trim()) { y += 1.2; continue; }
        absatz(teile[q], 8.5, false, [51, 71, 79], 0.8);
      }
    }
    block('Leistungsumfang und Voraussetzungen', cfg.voraussetzungen);
    block('Grundlage und Anpassung', (verbindlich ? cfg.anpassung : cfg.anpassungAuskunft) || cfg.anpassung);
    block(verbindlich ? 'Annahme, Zahlung und Geltung' : 'Preisbindung, Zahlung und Geltung',
      (verbindlich ? cfg.annahme : cfg.annahmeAuskunft) || cfg.annahme);

    /* ---- Fuss auf jeder Seite, mit Seitenzahl ---- */
    var seiten = doc.internal.getNumberOfPages();
    for (var s = 1; s <= seiten; s++) {
      doc.setPage(s);
      doc.setDrawColor(201, 214, 218); doc.setLineWidth(0.2);
      doc.line(L, 276, R, 276);
      stil(7.5, false, GRAU);
      doc.text(nurText(cfg.firma), L, 280);
      doc.text(nurText(cfg.anschrift), L, 283.4);
      doc.text(nurText(cfg.kontakt).split('\n')[0] || '', 105, 280, { align: 'center' });
      doc.text(nurText(cfg.register).split('\n')[0] || '', 105, 283.4, { align: 'center' });
      doc.text('Seite ' + s + ' von ' + seiten, R, 280, { align: 'right' });
      doc.text('Alle Preise netto zzgl. MwSt.', R, 283.4, { align: 'right' });
    }
    return doc;
  };

  /* Die Bibliothek erst beim Klick holen. */
  function jspdfLaden(fertig) {
    if (root.jspdf && root.jspdf.jsPDF) { return fertig(root.jspdf.jsPDF); }
    var s = document.createElement('script');
    s.src = JSPDF_QUELLE;
    s.crossOrigin = 'anonymous';
    var erledigt = false;
    function einmal(wert) { if (erledigt) { return; } erledigt = true; fertig(wert); }
    s.onload = function () { einmal(root.jspdf && root.jspdf.jsPDF ? root.jspdf.jsPDF : null); };
    s.onerror = function () { einmal(null); };
    setTimeout(function () { einmal(root.jspdf && root.jspdf.jsPDF ? root.jspdf.jsPDF : null); }, 8000);
    document.head.appendChild(s);
  }

  /* Wo im Bild steht ueberhaupt etwas?
     Die Logodatei im Shop ist eine 16:9-Flaeche mit rund 11 % leerem Rand auf
     jeder Seite (Befund MO, 02.09.2026 - das Zeichen wirkte dadurch verloren).
     Gesucht wird auf einer verkleinerten Kopie: 400 Pixel breit reichen fuer die
     Raender voellig und kosten nichts. Gefunden wird alles, was weder durch-
     sichtig noch nahezu weiss ist. */
  function inhaltsRahmen(img) {
    var breit = Math.min(400, img.naturalWidth || 0);
    if (!breit) { return null; }
    var hoch = Math.max(1, Math.round((img.naturalHeight * breit) / img.naturalWidth));
    var c = document.createElement('canvas');
    c.width = breit; c.height = hoch;
    var ctx = c.getContext('2d');
    ctx.drawImage(img, 0, 0, breit, hoch);
    var p = ctx.getImageData(0, 0, breit, hoch).data;   /* wirft bei fremder Herkunft */
    var minx = breit, miny = hoch, maxx = -1, maxy = -1;
    for (var yy = 0; yy < hoch; yy++) {
      for (var xx = 0; xx < breit; xx++) {
        var i = (yy * breit + xx) * 4;
        if (p[i + 3] > 12 && !(p[i] > 245 && p[i + 1] > 245 && p[i + 2] > 245)) {
          if (xx < minx) { minx = xx; }
          if (yy < miny) { miny = yy; }
          if (xx > maxx) { maxx = xx; }
          if (yy > maxy) { maxy = yy; }
        }
      }
    }
    if (maxx < 0) { return null; }                       /* leeres Bild - nicht zuschneiden */
    return {
      x: minx / breit, y: miny / hoch,
      b: (maxx - minx + 1) / breit, h: (maxy - miny + 1) / hoch
    };
  }

  /* Das Logo als Bilddaten, auf seinen Inhalt beschnitten. Klappt das nicht
     (kein CORS, Bild weg), traegt das Dokument den Schriftzug - ein Angebot ohne
     Kopf gibt es nicht. */
  function logoLaden(cfg, fertig) {
    var src = cfg.logoUrl || '';
    if (src.indexOf('//') === 0) { src = 'https:' + src; }
    if (!src || typeof document === 'undefined') { return fertig(null); }
    var erledigt = false;
    function einmal(wert) { if (erledigt) { return; } erledigt = true; fertig(wert); }
    var img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = function () {
      try {
        var bw = img.naturalWidth, bh = img.naturalHeight;
        var sx = 0, sy = 0, sb = bw, sh = bh;
        var r = null;
        try { r = inhaltsRahmen(img); } catch (fehler) { r = null; }
        /* Nur zuschneiden, wenn wirklich Rand da ist und genug Bild bleibt -
           ein Zuschnitt auf fast nichts waere schlimmer als der Rand. */
        if (r && r.b > 0.2 && r.h > 0.2 && (r.b < 0.97 || r.h < 0.97)) {
          sx = Math.floor(r.x * bw); sy = Math.floor(r.y * bh);
          sb = Math.max(1, Math.round(r.b * bw)); sh = Math.max(1, Math.round(r.h * bh));
        }
        /* Auf ein vernuenftiges Mass bringen: das Logo steht rund 38 mm breit im
           Dokument, 1000 Bildpunkte sind dafuer weit mehr als druckscharf. Ohne
           diese Grenze traegt jedes Angebot die 4000-Punkte-Datei mit sich. */
        var zb = Math.min(sb, 1000);
        var zh = Math.max(1, Math.round((sh * zb) / sb));
        var c = document.createElement('canvas');
        c.width = zb; c.height = zh;
        var zc = c.getContext('2d');
        if (zc.imageSmoothingQuality) { zc.imageSmoothingQuality = 'high'; }
        zc.drawImage(img, sx, sy, sb, sh, 0, 0, zb, zh);
        einmal({ daten: c.toDataURL('image/png'), breite: zb, hoehe: zh });
      } catch (err) { einmal(null); }
    };
    img.onerror = function () { einmal(null); };
    setTimeout(function () { einmal(null); }, 4000);
    img.src = src;
  }

  /* Der Weg, den der Kunde geht: Knopf - Datei im Download-Ordner. */
  BP.angebotPdf = function (stand) {
    var cfg = root.BP_AP_CFG || {};
    var verbindlich = ((stand.eingabe && stand.eingabe.ap) || 0) <= (cfg.grenzeAp || 19);
    var art = verbindlich ? 'Angebot' : 'Preisauskunft';
    var knopf = el('bp-ap-angebot-knopf');
    var alterText = knopf ? knopf.textContent : '';
    if (knopf) { knopf.disabled = true; knopf.textContent = art + ' wird erstellt …'; }
    function zurueck() { if (knopf) { knopf.disabled = false; knopf.textContent = alterText; } }

    jspdfLaden(function (jsPDF) {
      if (!jsPDF) {
        /* Bibliothek nicht erreichbar: der Kunde bekommt das Dokument im Fenster,
           mit Druckknopf. Lieber ein anderer Weg als gar keiner. */
        zurueck();
        BP.angebotDrucken(stand);
        return;
      }
      logoLaden(cfg, function (logo) {
        try {
          var doc = BP.pdfBauen(stand, jsPDF, logo, cfg);
          doc.save(art + '_' + stand.nummer + '.pdf');
          zaehler('angebot_pdf', { bp_angebotsnummer: stand.nummer, bp_dokumentart: art, bp_ap: stand.eingabe.ap });
        } catch (err) {
          BP.angebotDrucken(stand);
        }
        zurueck();
      });
    });
  };

  root.BPAngebotsplaner = BP;

  if (typeof document !== 'undefined') {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { BP.init(); });
    } else { BP.init(); }
  }

  if (typeof module !== 'undefined' && module.exports) { module.exports = BP; }

})(typeof window !== 'undefined' ? window : globalThis);
